import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <section className="footerContainer">
      <div className="footer">
        <div className="footerSocialMedia">
          <a
            href="https://www.facebook.com/nuralam.noyon.5"
            className="footer__socialIcon"
          >
            <i className="fab fa-facebook-f"></i>
          </a>

          <a
            href="https://www.linkedin.com/in/nur-alam-noyon-2835681b8/"
            className="footer__socialIcon"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>

          <a
            href="https://www.instagram.com/nur_alam_noyon/"
            className="footer__socialIcon"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>

        <div className="footerInfos">
          <div className="footerInfo">
            <span className="footerInfo__title">Ecom Plus BD</span>
            <span className="footerInfo__desc">E-commerce Expert</span>
          </div>
        </div>

        <div className="footerCopyRight">
          <p>© 2024 Ecom Plus BD. All rights reserved.</p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
